import { ClassificationQueue } from '../modules/accounting/index.js';
import { useCompanyScope } from './company-context.js';
import { GatedCompanyScreen } from './gated-company-screen.js';
import type { ClassificationView } from './list-views.js';
import type { ViewSetter } from './view-state.js';

export function CompanyClassificationScreen({
  view,
  onView,
}: {
  view: ClassificationView;
  onView: ViewSetter<ClassificationView>;
}) {
  const { can, company, today } = useCompanyScope();
  const units = company.businessUnits ?? [];
  /// Declarar grava um fato do extrato, e gravar acontece numa unidade escolhida (ADR 0039).
  const inUnit = units.length <= 1 || (company.activeBusinessUnitId ?? null) !== null;
  return (
    <GatedCompanyScreen allowed={can('accounting.classify')}>
      <ClassificationQueue
        view={view}
        onView={onView}
        today={today}
        canDeclare={inUnit && can('financial_reconciliation.settle')}
      />
    </GatedCompanyScreen>
  );
}
